import { useLocation, useNavigate } from "@tanstack/react-router";
import { Navbar as BNavbar, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";
import { useAuth } from "@/hooks/useAuth";
import useConfig from "@/hooks/useConfig";
import logo from "@/images/logo-wordmark-reverse.svg";
import { FIRM_NAME_KEY } from "@/lib/constants";
import styles from "./Navbar.module.scss";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const isVerificationPage = location.pathname === "/";
  const [firmName] = useLocalStorage(FIRM_NAME_KEY, "");
  const { logout, isAuthenticated } = useAuth();
  const { config } = useConfig();
  const apiUrl = config?.ApiUrl ?? import.meta.env.VITE_API_URL;

  const handleLogout = async () => {
    const response = await fetch(`${apiUrl}/Account/logout`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error("Logout failed");
    }
    await navigate({ to: "/" });
    logout();
  };

  // Remove the isEngToggled state and use i18n.language directly
  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "es" : "en";
    void i18n.changeLanguage(newLang);
  };

  return (
    <BNavbar
      className={`${isVerificationPage && styles.homePage}`}
      expand="sm"
      bg="dark"
      variant="dark"
    >
      <Container>
        <div className={styles.navbarContainer}>
          <div className={styles.leftSide}>
            <span>{firmName ? firmName : ""}</span>
          </div>
          <div className={styles.rightSide}>
            <div className={styles.navLinks}>
              <input
                type="button"
                className={styles.languageButton}
                onClick={() => toggleLanguage()}
                value={i18n.language === "en" ? "Español" : "English"}
              />
            </div>
            {isAuthenticated && (
              <input
                type="button"
                className={styles.logoutButton}
                onClick={handleLogout}
                onKeyDown={(e) => e.key === "Enter" && handleLogout()}
                tabIndex={0}
                value={t("formLabels.labelLogout")}
              />
            )}
            <div className={styles.securedBy}>
              <BNavbar.Brand href="/">
                {t("verification.navBarSecuredBy")}
                <img src={logo} alt="logo" className="logo" />
              </BNavbar.Brand>
            </div>
          </div>
        </div>
      </Container>
    </BNavbar>
  );
}
